import { IconFont } from '@/components'
import ADLogo from '@/assets/explore/ad-logo.png'

export function AdContainer() {
  const jumpClientPage = () => {
    const WEBSITE_URL = import.meta.env.VITE_HOME_WEBSITE_URL
    window.open(`${WEBSITE_URL}/download`)
  }
  return (
    <div className='flex-1'>
      <div className='mt-40px mb-24px text-16px text-#17171d font-600'>
        AI应用
      </div>
      <div
        className='w-full p-20px bg-#FFFFFF rounded-12px gap-x-16px cursor-pointer hover:shadow-[0_8px_24px_0px_rgba(23,23,29,0.12)]'
        onClick={jumpClientPage}
      >
        <div className='flex items-center gap-x-16px'>
          <img
            src={ADLogo}
            alt='ADLogo'
            className='w-60px h-60px rounded-12px'
          />
          <div className='flex-1 overflow-hidden'>
            <span className='text-16px/24px font-600 c-#17171D'>Yeah客服</span>
            <span className='text-13px/20px c-#8D8D99 block mt-8px overflow-hidden whitespace-nowrap text-ellipsis'>
              涵盖电商全平台，随时随地唤起，辅助客服快速专业问答
            </span>
          </div>
        </div>
        <button className='bg-#FFFFFF rounded-8px border-1 border-solid mt-16px w-full flex-center gap-x-4px c-#7B61FF border-#E1E1E599 hover:bg-#62699914'>
          <span className='py-8px text-13px/16px font-500'>了解更多</span>
          <IconFont name='qianwang' className='text-16px/16px' />
        </button>
      </div>
    </div>
  )
}
